// extracted by mini-css-extract-plugin
export default {"formFAQ":"FormFAQ_formFAQ__iSkWQ","actions":"FormFAQ_actions__+Ou5P"};